import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import Login from './login';
// import liff from '@line/liff';

// liff.init({
//     liffId: '1234567890-AbcdEfgh', // Use own liffId
// });


// import ReactGA from 'react-ga4';

// import liff from '@line/liff';



class App extends Component {

  // componentDidMount() {  
  //   // try{
  //   //   ReactGA.initialize("G-DYMNWFQVJM", {
  //   //     gaOptions: {
  //   //       name: 'myTracker',
  //   //       clientId: 'test'
  //   //     }
  //   //   });
  //   //   // Send pageview with a custom path
  //   //   ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  //   //   ReactGA.send({ hitType: "scrolls", page: window.location.pathname });
      
  //   //   // ReactGA.event('login');
      
  //   //   // Send a custom event
  //   //   ReactGA.event({
  //   //     category: "testCategory",
  //   //     action: "testAction",
  //   //     label: "testLabel",
  //   //   });

  //   //   console.log(ReactGA);
      
  //   // }catch(e){
  //   //   console.log(e);
  //   // }
  // }

  render() {
    return (
      <div className="App">
        <div className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h2>Welcome to React auto dddd</h2>
        </div>
        <p className="App-intro">
          To get started, edit <code>src/App.js</code> and save to reload.
        </p>
        <Login />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js